module.exports = __webpack_public_path__ + "img/support_d4.15235bb3.png";